<template>
  <div>
    <GenericH4>Andra befattningar</GenericH4>
    <ul>
      <li
        v-for="personalInfo in personalInfos"
        :key="`${personalInfo.ssn}-${personalInfo.companyName}-${personalInfo.roleType}`"
      >
        <h3 class="name capitalize-first">
          {{ personalInfo.companyName }}
          <small
            v-if="getDeregistrationDate(personalInfo)"
            style="color: var(--color-red)"
            >(Konkurs inledd {{ getDeregistrationDate(personalInfo) }})</small
          >
        </h3>
        <ul class="apartment-info">
          <li><b>Befattning:</b> {{ personalInfo.roleType }}</li>
          <li><b>Antal anställda:</b> {{ personalInfo.employees }}</li>
          <li><b>Omsättning:</b> {{ personalInfo.revenue }}</li>
          <li><b>Vinstmarginal i %:</b> {{ personalInfo.profitMargin }}</li>
        </ul>
        <br />
      </li>
    </ul>
  </div>
</template>

<script>
import GenericH4 from '@/components/GenericH4.vue';

export default {
  components: {
    GenericH4
  },
  props: {
    personalInfos: {
      type: Array,
      required: true
    }
  },
  methods: {
    getDeregistrationDate(personalInfo) {
      if (!personalInfo.deregistrationDate) {
        return null;
      }
      return new Date(personalInfo.deregistrationDate).toLocaleDateString(
        'sv-SE'
      );
    }
  }
};
</script>

<style></style>
